import {User} from './user';
import {Car, CarCheck} from './car';
import {Tenant, TenantScope} from './tenant';

export class Location {
    constructor(obj){
        if(!obj){
            return;
        }

        this.id = obj.id;
        this.status = obj.status;
        if(obj.user){
            this.user = new User(obj.user);
        }
        if(obj.company){
            this.company = obj.company;
        }
        this.commentaire = obj.commentaire;
        if(obj.grille){
            this.grille = obj.grille;
            this.grille = obj.grille;
        }
        if(obj.usedTarif){
            this.usedTarif = obj.usedTarif;
        }
        if(obj.start){
            this.start = new CarCheck(obj.start);
        }
        if(obj.end){
            this.end = new CarCheck(obj.end);
        }
        if(obj.car){
            this.car = new Car(obj.car);
        }
        if(obj.startTime){
            this.startTime = new Date(obj.startTime);
        }
        if(obj.endTime){
            this.endTime = new Date(obj.endTime);
        }
        this.nbChaufeurAdditionel = obj.nbChaufeurAdditionel;
        this.prix = [];
        if(obj.prix && obj.prix.length){
            this.prix = obj.prix.map(p => new LocCharge(p));
        }
        this.supplementsPrix = [];
        if(obj.supplementsPrix && obj.supplementsPrix.length){
            this.supplementsPrix = obj.supplementsPrix.map(sp => new LocCharge(sp));
        }
        this.montantTTC = obj.montantTTC;
        this.montantTTCSupp = obj.montantTTCSupp;
        this.paiements = [];
        if(obj.paiements && obj.paiements.length){
            this.paiements = obj.paiements.map(p => new LocPaiement(p));
        }
        this.notifierClientEMAIL = !!obj.notifierClientEMAIL;
        this.renew = !!obj.renew;

        this.startTimeString = obj.startTimeString;
        this.endTimeString = obj.endTimeString;

        if(obj.tenant){
            this.tenant = new Tenant(obj.tenant);
        }
    }
}

export class LocCharge{
    constructor(obj){
        if(!obj){
            return;
        }

        this.id = obj.id;
        this.chargeType = obj.chargeType;
        this.libele = obj.libele;
        this.description = obj.description;
        this.validated = !!obj.validated;
        this.unite = obj.unite;
        this.prixUnite = obj.prixUnite;
        this.tva = obj.tva;
        this.ht = obj.ht;
        this.taxe = obj.taxe;
        this.ttc = obj.ttc;
        this.formattedTTC = obj.formattedTTC;
    }
}

export const LocPaiementType = {
    PAIEMENT: 'PAIEMENT',
    CAUTION: 'CAUTION',
    VALUES: ['PAIEMENT', 'CAUTION']
};

export const Moyen = {
    CARTE: 'CARTE', VIREMENT: 'VIREMENT', CHEQUE: 'CHEQUE', ESPECE: 'ESPECE', PRELEVEMENT: 'PRELEVEMENT', CARTE_TPE: 'CARTE_TPE',
    VALUES: ['CARTE', 'VIREMENT', 'CHEQUE', 'ESPECE', 'PRELEVEMENT', 'CARTE_TPE']
};

export class LocPaiement extends TenantScope {
    constructor(obj){
        super(obj);

        if(!obj){
            return;
        }

        this.id = obj.id;
        this.type = obj.type;
        this.moyen = obj.moyen;
        this.label = obj.label;
        this.description = obj.description;
        this.montant = obj.montant;
        this.status = obj.status;
        this.statusMsg = obj.statusMsg;
        this.transactionId = obj.transactionId;
    }
}
